import api from '../utils/api';
import {SEARCH_GET_SERVICES} from '../utils/types';


export const getServiceByCategory = (data, ...extra) => ({
    type: SEARCH_GET_SERVICES,
    payload: api.post(`/search/services`,data,...extra)
});